export enum ROUTE {
  home = '/',
  signUp = '/sign-up',
  logIn = '/log-in',
  forgotPassword = '/forgot-password',
  forgotPasswordConfirm = '/forgot-password-confirm',
  intro = '/introduction',
  sms = '/app',
  password = '/password',
  signUpDetails = '/sign-up-details',
  signCallback = '/login/callback',
  signoutCallback = '/logout',

  newHome = '/new-home',
  course = '/course/:id',
}
